import InputGroup from "../InputGroup";
import BenefitDetailPreview from "./BenefitDetailPreview";
import {Button, RadioGroup, TextInput} from "omoplay";
import React, {useEffect} from "react";
import ImageForm from "../../ImageForm";

const BenefitDetail = ({benefitDetails, onBenefitImage, onBenefitPrecautionTitle, onBenefitPrecautionMessage,
                           onBenefitLink, onShowAddress, onBenefitCode, onUseCodePool}) => {
    const benefitData = benefitDetails().benefit
    const benefitImage = benefitData.prizeImage
    const benefitPrecautionTitle = benefitData.prizeCautionTitle ?? benefitDetails().title
    const benefitPrecautionMessage = benefitData.prizeCautionDescription ?? benefitDetails().precaution
    const linkUrl = benefitData.linkUrl
    const code = benefitData.code

    useEffect(() => {
        if (!benefitData.prizeCautionTitle) {
            onBenefitPrecautionTitle(benefitPrecautionTitle)
        }
        if (!benefitData.prizeCautionDescription) {
            onBenefitPrecautionMessage(benefitPrecautionMessage)
        }
    }, [])

  return (
      <InputGroup label="혜택 상세 화면" description="혜택에 대한 상세 화면을 설정해 주세요.">
          <div className="flex">
              <div className="flex flex-1">
                  <div className="flex-col flex-1 mr-[12px]">
                      <div className="flex-col gap-2">
                          <div className="font-semibold">혜택 이미지</div>
                          <ImageForm imageUrl={benefitImage} benefitName={benefitData.name} onChangeImageUrl={(url) => {
                              onBenefitImage(url)
                          }} showAIButton={true}>
                          </ImageForm>
                      </div>
                      <div className="flex-col gap-2 mt-[50px]">
                          <div className="font-semibold">혜택 유의사항 안내</div>
                          <div className="flex-col gap-2 p-[16px]" style={{backgroundColor: "var(--color-shape-depth1)"}}>
                              <div>제목</div>
                              <div>
                                  <TextInput value={benefitPrecautionTitle}
                                             onChange={(e) => onBenefitPrecautionTitle(e.target.value)}
                                             maxLength={20}
                                  />
                              </div>
                              <div>내용</div>
                              <div>
                                  <textarea
                                      className="bg-white border border-gray-300 text-gray-900 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block w-full p-2 resize-none text-xs whitespace-pre-line"
                                      onChange={(e) => onBenefitPrecautionMessage(e.target.value)}
                                      rows={10}
                                      value={benefitPrecautionMessage}
                                  ></textarea>
                              </div>
                          </div>
                      </div>
                      {
                          benefitData.type === "CODE" && (
                              <div className="flex-col gap-2 mt-[50px]">
                                  <div className="font-semibold">혜택 코드 설정</div>
                                  <select
                                      value={benefitData.useCodePool ? 'pool' : 'static'}
                                      onChange={(e) => onUseCodePool(e.target.value === 'pool')}
                                      className="w-full text-sm border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 py-1.5 mb-2"
                                  >
                                      <option value="static">고정코드</option>
                                      <option value="pool">범위랜덤코드</option>
                                  </select>
                                  {
                                      benefitData.useCodePool ? (
                                          <div>담당자에게 문의해주세요</div>
                                      ) : (
                                          <div className="w-full">
                                              <TextInput value={code}
                                                         onChange={(e) => onBenefitCode(e.target.value)}
                                                         placeholder="1000-1234-5678" maxLength={20} />
                                          </div>
                                      )
                                  }
                              </div>
                          )
                      }
                      {
                          benefitData.type === "LINK" && (
                              <div className="flex-col gap-2 mt-[50px]">
                                  <div className="font-semibold">혜택 링크 설정</div>
                                  <div className="flex-align-center gap-4">
                                      <div style={{flex: "1"}}>
                                          {/* placeholder 가 완성된 URL 형태(`https://www.omoplay.com`)라 이미 입력된 값처럼 보였다
                                              → 빈칸임을 알 수 있게 안내문으로 바꾼다(2026-07-30 피드백). */}
                                          <TextInput value={linkUrl ?? ""}
                                                     onChange={(e) => onBenefitLink(e.target.value)}
                                                     placeholder="연결할 페이지 주소를 입력해주세요 (https:// 포함, 필수)"
                                                     maxLength={200} />
                                      </div>
                                      <div><Button variants="secondary" value="URL 확인" onClick={() => {
                                          window.open(linkUrl)
                                      }} /></div>
                                  </div>
                              </div>
                          )
                      }
                      {
                          benefitData.type === "DELIVERY" && (
                              <div className="flex-col gap-2 mt-[50px]">
                                  <div className="font-semibold">주소 입력 여부</div>
                                  <div>
                                      <RadioGroup items={[{label: "사용 안함", value: "disabled"}, {label: "사용", value: "enabled"}]}
                                                  initChecked={benefitData.showAddress ? "enabled" : "disabled"}
                                                  onSelected={(value) => {
                                                      onShowAddress(value)
                                                  }} />
                                  </div>
                              </div>
                          )
                      }
                  </div>
              </div>
              <div className="bg-grey-0 flex-center-all flex-1 ml-[12px]">
                  <BenefitDetailPreview benefitData={benefitData} />
              </div>
          </div>
      </InputGroup>
  )
};

export default BenefitDetail;
